import { Head, useForm, usePage } from "@inertiajs/react";
import { SubmitEvent } from "react";
import TeamForm from "./_form";
import { CurrentUser, TeamFormData } from "@/types/shared";

interface RosterEntry {
  email: string;
  isOwner: boolean;
}

interface EditTeamParticipantProps {
  team: {
    id: number;
    description: string;
  };
  participant: {
    id: number;
    name: string;
    location: string;
    email: string;
    phone_number: string;
    instagram: string;
  };
  roster: RosterEntry[];
  pending_roster: { email: string }[];
  errors?: string[];
}

export default function EditTeamParticipant({
  team,
  participant,
  roster,
  pending_roster,
  errors,
}: EditTeamParticipantProps) {
  const { currentUser } = usePage<{ currentUser: CurrentUser }>().props;

  const { data, setData, patch, processing } = useForm<TeamFormData>({
    participant: {
      name:         participant.name,
      location:     participant.location,
      email:        participant.email,
      phone_number: participant.phone_number,
      instagram:    participant.instagram,
    },
    team: {
      description: team.description,
      logo:        null,
      photos:      [],
    },
    invited_emails: roster.filter((m) => !m.isOwner).map((m) => m.email),
  });

  const handleSubmit = (e: SubmitEvent) => {
    e.preventDefault();
    patch("/team_participant", { forceFormData: true });
  };

  // Build the full initial roster: accepted members + pending invites shown as "invited"
  const initialRoster = [
    ...roster.map((m) => ({ email: m.email, isOwner: m.isOwner, onPlatform: true })),
    ...pending_roster.map((m) => ({ email: m.email, isOwner: false, onPlatform: true })),
  ];

  return (
    <>
      <Head title="Edit Team" />
      <div style={{ maxWidth: 680, margin: "0 auto", padding: "2rem 1.5rem 4rem" }}>
        <TeamForm
          data={data}
          setData={setData}
          onSubmit={handleSubmit}
          processing={processing}
          errors={errors}
          currentUserEmail={currentUser?.email ?? ""}
          title="Edit Team"
          submitLabel="Save Changes"
          initialRoster={initialRoster}
        />
      </div>
    </>
  );
}
